var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(("width:100%;height:" + _vm.dispH + "px;border-top:1px solid gray;"))},[_c('canvas',{attrs:{"id":"thickCanvas","width":"920px","height":((_vm.dispH - 10) + "px")}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79ae84b1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/topography/components/RGP-Thick.vue
// module id = null
// module chunks = 